import React from 'react';
import loadable from '@app/ui/components/LazyLoad';
import { useShowMobileLocationSelector } from '../../hooks';

const LocationSelectorDrawer = loadable(
  () =>
    import(
      /* webpackChunkName: "lazy.LocationSelectorDrawer" */ './LocationSelectorDrawer'
    ),
);

const LazyLocationSelectorDrawer = () => {
  const showMobileLocationSelector = useShowMobileLocationSelector();

  if (!showMobileLocationSelector) {
    return null;
  }

  return <LocationSelectorDrawer />;
};

export default LazyLocationSelectorDrawer;
